<template>
  <div class="comment_detail">
    <a-spin tip="loading" v-if="loading" id="loading" size="large">
      <div class="spin-content"></div>
    </a-spin>
    <div v-else>
      <header>
        <a-row class="header">
          <a-col :span="3" class="header-right">
            <i @click="$router.go(-1)"></i>
          </a-col>
          <a-col :span="18" class="header-title">
            <span>{{ $t("workingWall.CommentsDetail") }}</span>
          </a-col>
          <a-col :span="3">
            <router-link
              tag="div"
              :to="{
                path: '/main/add_question',
                query: { id: this.$route.query.kid, from: 'working_wall' },
              }"
              class="add_comment"
            >
              <i></i>
            </router-link>
          </a-col>
        </a-row>
      </header>
      <mescroll-vue :down="mescrollDown" :up="mescrollUp" @init="mescrollInit">
        <a-row class="comment_row">
          <a-col :span="4" class="comment_avator">
            <img
              :src="
                qaDetail.user_head_img != ''
                  ? qaDetail.user_head_img
                  : defaultImg
              "
              alt
              :onerror="errorImg"
            />
          </a-col>
          <a-col :span="20">
            <a-row>
              <a-col :span="18" class="comment_author">{{
                qaDetail.user_name
              }}</a-col>
              <a-col :span="6" class="comment_time">{{
                qaDetail.created_at
              }}</a-col>
            </a-row>
            <a-row>
              <a-col :span="24" class="coment_content">{{
                qaDetail.txt
              }}</a-col>
            </a-row>
          </a-col>
        </a-row>
        <div class="line"></div>
        <div class="comment_replay">
          {{ count }}{{ $t("workingWall.ReplayComment") }}
        </div>
        <div v-if="qaReply.length != 0">
          <a-row
            class="comment_row"
            v-for="(qa_reply, rindex) in qaReply"
            :key="rindex"
          >
            <a-col :span="4" class="comment_avator">
              <img
                :src="
                  qa_reply.user_head_img != ''
                    ? qa_reply.user_head_img
                    : defaultImg
                "
                alt
                :onerror="errorImg"
              />
            </a-col>
            <a-col :span="20">
              <a-row>
                <a-col :span="18" class="comment_author">{{
                  qa_reply.user_name
                }}</a-col>
                <a-col :span="6" class="comment_time">{{
                  qa_reply.created_at
                }}</a-col>
              </a-row>
              <a-row>
                <a-col :span="24" class="coment_content">{{
                  qa_reply.txt
                }}</a-col>
              </a-row>
            </a-col>
          </a-row>
        </div>
        <div class="no-data" v-else>
          <div v-show="isShow">
            <div class="no-img"></div>
            <h5>{{ $t("workingWall.length") }}</h5>
          </div>
        </div>
      </mescroll-vue>
      <!-- 回复 -->
      <div class="comment_footer">
        <input
          :placeholder="$t('workingWall.content')"
          class="commment_input"
          v-model="my_reply"
        />
        <a-button type="primary" class="comment_button" @click="reply_dis">{{
          $t("workingWall.Send")
        }}</a-button>
      </div>
    </div>
  </div>
</template>
<script>
import MescrollVue from "mescroll.js/mescroll.vue";
import defaultImg from "../../assets/img/learning_camp/basic_fc.png";
export default {
  name: "commentDetail",
  data() {
    return {
      defaultImg,
      errorImg:
        'this.src="' + require("@/assets/img/learning_camp/basic_fc.png") + '"',
      loading: true,
      qaDetail: [],
      qaReply: [],
      count: 0,
      my_reply: "",
      mescroll: null, // mescroll实例对象
      mescrollDown: {
        textInOffset: this.$t("public.pullRefresh"),
        textOutOffset: this.$t("public.releaseRefresh"),
        textLoading: this.$t("public.loadtip"),
      }, // 下拉刷新的配置. (如果下拉刷新和上拉加载处理的逻辑是一样的,则mescrollDown可不用写了)
      mescrollUp: {
        htmlLoading: `<p class="upwarp-progress mescroll-rotate"></p><p class="upwarp-tip">${this.$t(
          "public.loadtip"
        )}</p>`,
        // 上拉加载的配置.
        // warpId: "scrollBlock",
        callback: this.get_question_reply,
        page: {
          num: 0, // 当前页 默认0,回调之前会加1; 即callback(page)会从1开始
          size: 10, // 每页数据条数,默认10
        },
        htmlNodata:
          '<p style="font-size:0.22rem">' +
          this.$t("workingWall.noMoreData") +
          "</p>",
      },
      submit: true,
      isShow: false,
      num:
        localStorage.getItem("num") == null ? 1 : localStorage.getItem("num"),
    };
  },
  components: {
    MescrollVue,
  },
  created() {
    // this.$i18n.locale = "zh";
    this.get_question_detail();
  },
  methods: {
    get_question_detail() {
      var _this = this;
      var url = "index.php/mobile/homework/comment-detail";
      var params = {
        user_id: localStorage.getItem("_user_data_id"),
        company_id: localStorage.getItem("_user_data_company_id"),
        sso_token: localStorage.getItem("_user_data_sso_token"),
        sys_id: localStorage.getItem("_sys_id"),
        language: localStorage.getItem("_user_data_language"),
        source_id: this.$route.query.kid,
        id: this.$route.query.did,
      };
      _this.$axios.post(url, params).then((res) => {
        // console.log(res);
        if (res.data.code == 0) {
          _this.loading = false;
          _this.qaDetail = res.data.result;
        } else {
          if (res.data.code == 10600) {
            this.$router.push({ name: "Login" });
          } else {
            this.$toast(res.data.msg);
          }
        }
      });
    },
    get_question_reply(page, mescroll) {
      var _this = this;
      var url = "index.php/mobile/homework/reply-list";
      var params = {
        user_id: localStorage.getItem("_user_data_id"),
        company_id: localStorage.getItem("_user_data_company_id"),
        sso_token: localStorage.getItem("_user_data_sso_token"),
        sys_id: localStorage.getItem("_sys_id"),
        language: localStorage.getItem("_user_data_language"),
        source_id: this.$route.query.kid,
        parent_id: this.$route.query.did,
        page: page.num,
        size: page.size,
      };
      _this.$axios.post(url, params).then((res) => {
        // console.log(res)
        if (res.data.code == 0) {
          _this.count = res.data.result.pages.data_count; // 数量
          if (page.num === 1) _this.qaReply = [];
          _this.qaReply = _this.qaReply.concat(res.data.result.list);
          _this.isShow = true;
          this.$nextTick(() => {
            mescroll.endByPage(
              res.data.result.pages.data_count,
              res.data.result.pages.page_count
            );
          });
        } else {
          if (res.data.code == 10600) {
            this.$router.push({ name: "Login" });
          } else {
            this.$toast(res.data.msg);
          }
        }
      });
    },
    // mescroll组件初始化的回调,可获取到mescroll对象
    mescrollInit(mescroll) {
      this.mescroll = mescroll; // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
    },
    reply_dis() {
      window.scroll(0, 0);
      var _this = this;
      if (_this.my_reply.trim() == "") {
        _this.$toast(_this.$t("workingWall.kong"));
        return;
      }
      if (_this.my_reply.trim().length > 512) {
        _this.$toast(_this.$t("workingWall.over"));
        return;
      }
      if (_this.my_reply.trim().length < 10) {
        _this.$toast(_this.$t("public.lessTen1"));
        return false;
      }
      if (_this.submit) {
        _this.submit = false;
        var url = "index.php/mobile/homework/add-reply";
        var params = {
          user_id: localStorage.getItem("_user_data_id"),
          company_id: localStorage.getItem("_user_data_company_id"),
          sso_token: localStorage.getItem("_user_data_sso_token"),
          sys_id: localStorage.getItem("_sys_id"),
          language: localStorage.getItem("_user_data_language"),
          source_id: this.$route.query.kid,
          to_user_id: _this.qaDetail.user_id,
          parent_id: this.$route.query.did,
          txt: _this.my_reply,
        };
        _this.$axios.post(url, params).then((res) => {
          // console.log(res);
          _this.submit = true;
          if (res.data.code == 0) {
            _this.$toast(_this.$t("workingWall.add"));
            _this.my_reply = "";
            _this.mescroll.resetUpScroll();
            _this.$store.commit("working_wall/comment_num", _this.num++);
          } else {
            if (res.data.code == 10600) {
              this.$router.push({ name: "Login" });
            } else {
              this.$toast(res.data.msg);
            }
          }
        });
      }
    },
  },
  beforeDestroy() {
    localStorage.removeItem("num");
  },
};
</script>
<style scoped lang="less">
header {
  height: 0.75rem;
}
.header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 7;
  width: 100%;
  padding: 0.1rem 0.3rem;
  background: #f6f6f6;
  border-bottom: 0.01rem solid #ddd;
  display: flex;
  align-items: center;
  .header-title {
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      font-size: 0.32rem;
      color: #252631;
    }
    i {
      display: inline-block;
      width: 0.22rem;
      height: 0.03rem;
      background: #999999;
      margin: 0 0.1rem;
    }
  }
  .header-right {
    display: flex;
    align-items: center;
    i {
      display: inline-block;
      width: 0.18rem;
      height: 0.34rem;
      background: url("../../assets/img/facecourse/back.png") no-repeat
        center/contain;
      background-size: 100%;
    }
  }
  .add_comment {
    text-align: center;
    i {
      display: inline-block;
      width: 0.34rem;
      height: 0.34rem;
      background: url("../../assets/img/working-wall/yjicon.png") no-repeat
        center/contain;
      background-size: 100%;
      margin-top: 0.1rem;
    }
  }
}
.comment_detail {
  width: 100%;
  height: 100%;
  .comment_row {
    padding: 0.3rem 0;
    margin: 0 0.3rem;
    border-bottom: 1px solid #eee;
    background: #fff;
    .comment_avator {
      img {
        width: 0.76rem;
        height: 0.76rem;
        border-radius: 50%;
        pointer-events: none; //防止图片点击放大
      }
    }
    .comment_author {
      font-size: 0.26rem;
      font-weight: bold;
      color: #252631;
      .comment_grade {
        font-size: 0.26rem;
        color: rgb(211, 158, 122);
        &::after {
          content: "";
          display: block;
          width: 0.25rem;
          height: 0.25rem;
          background: url("../../assets/img/learning_camp/teacher.png")
            no-repeat center / contain;
          position: absolute;
          left: -0.5rem;
          top: 0.5rem;
        }
      }
    }
    .comment_time {
      font-size: 0.22rem;
      color: #7f8485;
    }
    .coment_content {
      font-size: 0.26rem;
      color: #7f8485;
    }
    .comment_dialog {
      font-size: 0.22rem;
      i {
        display: inline-block;
        width: 0.23rem;
        height: 0.23rem;
        margin-top: 0.1rem;
        background: url("../../assets/img/learning_camp/comment.png") no-repeat
          center/contain;
        background-size: 100%;
      }
    }
  }
  .line {
    width: 100%;
    height: 0.2rem;
    background: #f6f6f6;
  }
  .comment_replay {
    height: 0.88rem;
    line-height: 0.88rem;
    border-bottom: 1px solid #eee;
    font-size: 0.3rem;
    font-weight: bold;
    color: #252631;
    padding-left: 0.3rem;
  }
  .no-data {
    .no-img {
      width: 2.75rem;
      height: 2.75rem;
      background: url("~@/assets/img/new/no-date.png") no-repeat center/contain;
      background-size: 100%;
      margin: 1rem auto;
      margin-bottom: 0.5rem;
    }
    h5 {
      text-align: center;
    }
  }
  .comment_footer {
    background: #f6f6f6;
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 0;
    display: flex;
    padding: 0.21rem 0.3rem;
    .commment_input {
      height: 0.8rem;
      width: 100%;
      font-size: 0.26rem;
      border: 1px solid #eee;
      padding-left: 0.1rem;
    }
    .comment_button {
      margin-left: 0.1rem;
      height: 0.8rem;
      width: 1.5rem;
      font-size: 0.3rem;
    }
  }
}
.mescroll {
  position: fixed;
  top: 0.8rem;
  bottom: 1.2rem;
  height: auto;
}
/*隐藏掉滚动条*/
.mescroll::-webkit-scrollbar {
  display: none;
}
</style>
